import { render } from "./CommentTaskPreSvgIcon.vue?vue&type=template&id=116e3ec8"
import script from "./CommentTaskPreSvgIcon.vue?vue&type=script&lang=js"
export * from "./CommentTaskPreSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__